import React from 'react';
import { ISelectCatalogButtonProps } from './SelectCatalogButton.types';
import DeleteButton from 'components/DeleteButton';
import { ExistingEntryDetailsContent } from 'components/CatalogEntryDetailsContent';
import { Box } from 'rebass';

export const SelectCatalogButton: React.FC<ISelectCatalogButtonProps> = ({
  onClick,
  onDelete,
  onOpenModal,
  catalogEntry,
  editable,
  modalState,
}) => {
  if (!onDelete) {
    return <></>;
  }
  return (
    <>
      <span
        className={`catalog-entry-tooltip`}
        style={!catalogEntry ? { justifyContent: 'end' } : {}}
      >
        <span className={'tooltip-core'}>
          <Box display="flex" flexWrap={'nowrap'}>
            <button
              className={`${
                editable && !catalogEntry?.signature ? 'add-button' : 'catalog-entry-name'
              }`}
              onClick={(e) => {
                if (!catalogEntry?.signature && editable) {
                  onClick(e);
                } else {
                  catalogEntry &&
                    !modalState &&
                    onOpenModal(
                      <ExistingEntryDetailsContent edit_mode={false} catalogEntry={catalogEntry} />
                    );
                }
              }}
            >
              {catalogEntry?.signature
                ? `${catalogEntry?.signature}: ${catalogEntry?.title}`
                : 'Katalogeintrag hinzufügen'}
            </button>
            {editable && catalogEntry && (
              <DeleteButton className="no-text-delete-button" title=" " onDelete={onDelete} />
            )}
          </Box>
        </span>
      </span>
    </>
  );
};
